import register from 'ShopUiBundle/modules/app/registry';

import './style.scss';

// tslint:disable-next-line
register('catalog-products-dynamic', () => import(/* webpackMode: "lazy" */'./catalog-products-dynamic'));
